export const formatUsername = (email: string): string => {
  if (!email) return '';
  return email.split('@')[0];
};

export const phoneRegExp = /^\+\d{1,3}\d{10}$/;
